import ApiService from '@/services/core/api.service'

const AttachmentService = {
  async retrieve (requestId, fileName) {
    return ApiService.get(`disbursement/attachments/retrieve?request_id=${requestId}&file_name=${fileName}`)
  },

  async retrieveForm (fileName) {
    return ApiService.get(`disbursement/forms/retrieve?file_name=${fileName}`)
  }
}

export default AttachmentService
